import { Injectable } from '@angular/core';
import { Order } from '@datorama/akita';
import { AkitaFiltersPlugin } from 'akita-filters-plugin';
import { SalesCreditNote } from '../model/sales-credit-note.model';
import { SalesCreditNoteState } from '../store/sales-credit-note.store';
import { SalesCreditNoteQuery } from '../query/sales-credit-note.query';

@Injectable()
export class SalesCreditNoteFilterService<T extends SalesCreditNote> extends AkitaFiltersPlugin<SalesCreditNoteState<T>> {
  constructor(protected offerQuery: SalesCreditNoteQuery<T>) {
    super(offerQuery, { filtersStoreName: 'sales-credit-note-filter' });
    const fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() - 3);
    this.setFilter({
      id: 'dtEntryDate[gte]',
      value: fromDate.valueOf(),
      predicate: (entity: T) => {
        return entity.dtEntryDate >= fromDate.valueOf();
      },
    });
    this.setFilter({
      id: 'intPageIndex',
      value: 1,
      predicate: (_) => true,
    });
    this.setFilter({
      id: 'intPageSize',
      value: 10,
      predicate: (_) => true,
    });
  }

  /**
   * Sets orderBy
   */
  setOrderBy(by: any, order: string | '+' | '-') {
    this.setSortBy({
      sortBy: by,
      sortByOrder: order === '+' ? Order.ASC : Order.DESC,
    });
  }
}
